import React, {Component} from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as FActions from "../../../store/modules/footer";
import {PropTypes} from "prop-types";
import Popup from "../Popup";

import {BASE_PATH, JOURNAL_FACET_NAME, RESOURCE_FACET_NAME, SCHOLAR_FACET_NAME} from "../../../wpconfig"
import {getSelectFormat, objectToQueryString, pushUrl} from "../../../utils/functions"
import * as func from "../../../utils/functions";

class FrontFooter extends Component {
	constructor(props) {
		super(props);

		this.state = {
			'type': this.props.type
		}
	}

	deepClone(obj) {
		if (obj === null || typeof obj !== "object") {
			return obj
		}
		const result = Array.isArray(obj) ? [] : {}
		for (let key of Object.keys(obj)) {
			result[key] = this.deepClone(obj[key])
		}
		return result
	}

	facetAddEvent = (event) => {
		if (event.target.type === "button") {
			let param = this.props.param;
			// console.log(param)
			// console.log(event.target)
			// return;
			if (param[event.target.name].indexOf(event.target.value) < 0) {
				param[event.target.name].push(event.target.value);
			}
			func.getData(this.props.part, param).then((response) => {
				const url = objectToQueryString(param);
				if (this.props.part === 'journals') {
					this.props.dataActions.setJournals({"param": param});
					this.props.dataActions.setJournals(response);
				} else if (this.props.part === 'resources') {
					this.props.dataActions.setResources({"param": param});
					this.props.dataActions.setResources(response);
				} else if (this.props.part === 'scholars') {
					this.props.dataActions.setScholars({"param": param});
					this.props.dataActions.setScholars(response);
				}
				pushUrl('검색', BASE_PATH + this.props.part + '/?' + url, param);
			});
		}
	}

	facetRemoveEvent = (event) => {
		let param = this.props.param;
		if (param[event.target.name].indexOf(event.target.value) > -1) {
			param[event.target.name].splice(param[event.target.name].indexOf(event.target.value), 1);
		}
		func.getData(this.props.part, this.props.param).then((response) => {
			const url = objectToQueryString(param);
			if (this.props.part === 'journals') {
				this.props.dataActions.setJournals({"param": param});
				this.props.dataActions.setJournals(response);
			} else if (this.props.part === 'resources') {
				this.props.dataActions.setResources({"param": param});
				this.props.dataActions.setResources(response);
			} else if (this.props.part === 'scholars') {
				this.props.dataActions.setScholars({"param": param});
				this.props.dataActions.setScholars(response);
			}
			pushUrl('검색', BASE_PATH + this.props.part + '/?' + url, param);
		});
	}

	closePopupEvent = () => {
		this.props.fDataActions.setFooter({isPopup1: false});
	}

	render() {

		let temp = {};
		if (this.props.isPopup1 && this.props.type && this.props.facet[this.props.type]) {
			temp = this.deepClone(this.props.facet[this.props.type]);
			if (temp)
				temp.result = getSelectFormat(temp.result);
		} else {
			return '';
		}

		let title;
		if (this.props.part === 'journals')
			title = JOURNAL_FACET_NAME[this.props.type]
		else if (this.props.part === 'resources')
			title = RESOURCE_FACET_NAME[this.props.type]
		else if (this.props.part === 'scholars')
			title = SCHOLAR_FACET_NAME[this.props.type]

		// console.log(this.props.isPopup1)
		// console.log(this.props.type)
		// console.log(this.props.facet)

		return (
			<>
				{
					this.props.isPopup1 &&
					<Popup
						isShow
						isMulti
						name={this.props.type}
						title={title}
						data={temp.result}
						currentData={this.props.param[this.props.type]}
						onAdd={this.facetAddEvent}
						onRemove={this.facetRemoveEvent}
						closeEvent={this.closePopupEvent}
					/>
				}
				<div id="LineChartToolTip" className="line-chart-tooltip"/>
			</>
		)
	}
};

export default connect(
	(state) => ({
		isPopup1: state.footer.isPopup1,
		type: state.footer.type ? state.footer.type : "",
		part: state.footer.part ? state.footer.part : "",
	}),
	(dispatch) => ({
		fDataActions: bindActionCreators(FActions, dispatch)
	}),
)(FrontFooter)
